module.exports = __webpack_public_path__ + "img/AI.8314ed85.png";